import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";

const NAV = [
  { label: "Home", to: "/" },
  { label: "Wrestling", to: "/wrestling" },
  { label: "Comedy", to: "/comedy" },
  { label: "About", to: "/about" },
  { label: "Gallery", to: "/gallery" },
  { label: "Book A Show", to: "/book" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" style={{ background: "var(--black)" }}>
      <div className="hairline" />
      <div className="container-editorial" style={{ paddingTop: "clamp(3.5rem, 7vw, 6rem)", paddingBottom: "clamp(2.5rem, 5vw, 4rem)" }}>
        <div
          className="grid gap-12"
          style={{ gridTemplateColumns: "1fr", rowGap: "3rem" }}
        >
          <div className="footer-grid" style={{ display: "grid", gap: "clamp(2.5rem,5vw,4rem)" }}>
            <div>
              <img
                src="/assets/logo-white.png"
                alt="Hustle Promotions"
                style={{ height: "clamp(72px, 9vw, 120px)", width: "auto", display: "block", marginBottom: "1.5rem" }}
                data-testid="footer-logo"
              />
              <p className="body-md" style={{ maxWidth: "34ch", marginTop: 0 }}>
                Hustle Promotions — Professional Wrestling &amp; Stand-Up Comedy Shows.
              </p>
            </div>

            <div>
              <p className="eyebrow" style={{ marginBottom: "1.25rem" }}>Contact</p>
              <div className="flex flex-col" style={{ gap: "0.9rem" }}>
                <a
                  href="tel:+19802980100"
                  data-testid="footer-phone-link"
                  className="link-underline"
                  style={{ letterSpacing: "0.06em" }}
                >
                  <Phone size={16} strokeWidth={1.6} /> 980-298-0100
                </a>
                <a
                  href="mailto:Booking@HustlePromotionsLive.com"
                  data-testid="footer-email-link"
                  className="link-underline"
                  style={{ letterSpacing: "0.04em", textTransform: "none", fontSize: "0.9rem" }}
                >
                  <Mail size={16} strokeWidth={1.6} /> Booking@HustlePromotionsLive.com
                </a>
              </div>
            </div>

            <div>
              <p className="eyebrow" style={{ marginBottom: "1.25rem" }}>Explore</p>
              <nav className="flex flex-col" style={{ gap: "0.7rem" }}>
                {NAV.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    className="nav-link"
                    data-testid={`footer-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {item.label}
                  </Link>
                ))}
              </nav>
            </div>
          </div>

          <div className="hairline" />

          <div
            className="flex flex-col md:flex-row md:items-center md:justify-between"
            style={{ gap: "1rem" }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}>
              <p
                className="font-display"
                style={{ textTransform: "uppercase", letterSpacing: "0.16em", fontSize: "0.85rem", color: "var(--gray)", margin: 0 }}
                data-testid="footer-nc-line"
              >
                Professional Wrestling Available Across North Carolina
              </p>
              <p
                className="font-display"
                style={{ textTransform: "uppercase", letterSpacing: "0.16em", fontSize: "0.85rem", color: "var(--gray)", margin: 0 }}
                data-testid="footer-comedy-line"
              >
                Stand-Up Comedy — Contact For Booking Availability
              </p>
            </div>
            <p className="text-muted" style={{ fontSize: "0.8rem", margin: 0 }} data-testid="footer-copyright">
              © Hustle Promotions
            </p>
          </div>
        </div>
      </div>

      <style>{`
        @media (min-width: 768px) {
          .footer-grid { grid-template-columns: 1.4fr 1fr 1fr; align-items: start; }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
